<div class="stop-scheduling-suggestions">
  <span class="stop-scheduling-suggestions__title">
    {{ 'MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.TITLE' | translate }}
  </span>
  <span class="stop-scheduling-suggestions__description">
    {{ 'MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.DESCRIPTION' | translate }}
  </span>
  <div class="stop-scheduling-suggestions__buttons">
    <button
      class="stop-scheduling-suggestions__buttons__confirm"
      [disabled]="isLoading | async"
      (click)="stopSchedulingSuggestions()"
    >
      {{ 'MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.BUTTONS.CONFIRM' | translate }}
    </button>
    <button class="stop-scheduling-suggestions__buttons__cancel" [disabled]="isLoading | async" (click)="closeDialog()">
      {{ 'MAINTENANCES.STOP_SCHEDULE_SUGGESTIONS_DIALOG.BUTTONS.CANCEL' | translate }}
    </button>
  </div>
</div>
